import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import boardIcon from "../assets/board.png";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #000000",
    borderRadius: "0px !important",
  },
}));

const SpecialityName = ({ specialityList }) => {
  const getBoardCertificate = (specialtyVal) => {
    return (
      specialtyVal?.boardCertList?.boardCertification[0]?.boardCertStatus ==
        "Y" && (
        <HtmlTooltip title="Board Certified" placement="right-end">
          <img
            src={boardIcon}
            alt="Provider Search - Board Certified Image"
            style={{ marginRight: "-6px" }}
          />{" "}
        </HtmlTooltip>
      )
    );
  };

  return (
    <span className="left-align">
      {specialityList?.specialty?.length > 0 &&
        specialityList?.specialty.map((specialtyVal, indexspec) => (
          <span key={indexspec}>
            {specialtyVal.specialityName}
            {getBoardCertificate(specialtyVal)}
            {indexspec < specialityList?.specialty.length - 1 ? ", " : ""}
          </span>
        ))}
    </span>
  );
};

SpecialityName.propTypes = {
  specialityList: PropTypes.object,
};

export default SpecialityName;
